<script setup>

import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";
import KitModalHeader from "@/components/global-themed/ui/modals/KitModalHeader.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import ModalContentWrapper from "@/components/global-themed/ui/modals/ModalContentWrapper.vue";
import BaseModal from "@/components/global-themed/BaseModal.vue";
import {kitName} from "@/composables/useLocalDomains";
import DirectoryLogosCarousel from "./DirectoryLogosCarousel.vue";
import {useMutation} from "@tanstack/vue-query";
import axios from "axios";
import {useKitSignupState} from "@/composables/useKitSignupState";

const emit = defineEmits(['close']);

const { markSignupRequested } = useKitSignupState();

const {mutate: handleSignUp, isPending} = useMutation({
  mutationFn: async () => await axios.post('/ajax/v2/request-seo-agent-information'),
  onSuccess: () => {
    markSignupRequested();

    emit('close');

    window.location.href = '/dash';
  },
});
</script>

<template>
  <Teleport
    to=".tailwind"
  >
    <BaseModal
      modal-class="tw-w-[800px]"
      @close="emit('close')"
    >
      <ModalContentWrapper>
        <KitModalHeader>
          <ModalHeader>
            <ModalHeading>Sign up for {{ kitName }}</ModalHeading>
          </ModalHeader>
        </KitModalHeader>

        <div>
          <DirectoryLogosCarousel />

          <div class="tw-mt-6">
            <p class="tw-text-base tw-text-neutral-900">
              {{ kitName }} checks your existing citations and automatically builds new ones where you’re missing. It also updates incorrect or inconsistent information across key local platforms, keeping your business info accurate and trusted.
            </p>
            <br>
            <p class="tw-text-base tw-text-neutral-900">
              Above is a list of some of the other citations we would build.
            </p>
            <br>
            <p class="tw-text-base tw-text-neutral-900">
              To get started with {{ kitName }}, return to your dashboard and click the <strong>Upgrade</strong> banner to purchase. This is the quickest way to unlock {{ kitName }} and begin improving your business information.
            </p>
          </div>
        </div>

        <div class="tw-flex tw-items-center tw-gap-4 tw-self-end">
          <DefaultButton
            variant="primary-inverted"
            :disabled="isPending"
            @click="emit('close')"
          >
            Cancel
          </DefaultButton>
          <DefaultButton
            :disabled="isPending"
            @click="handleSignUp"
          >
            Go to Dashboard
          </DefaultButton>
        </div>
      </ModalContentWrapper>
    </BaseModal>
  </Teleport>
</template>

